import { useFormBuilder } from '../formContext';

export const FormPrevNewPage = () => {
    const { formList, activeSection, setActiveSection } = useFormBuilder();

    if (formList?.sections?.length < 2) {
        return '';
    }

    return (
        <div className="form-section-nav">
            <button className="prev-section-btn" disabled={activeSection === 1} onClick={() => setActiveSection((prev) => prev - 1)}>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.5 15L7.5 10L12.5 5" stroke="#344054" strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                Previous Section
            </button>

            <span className="section-indicator">
                Section {activeSection} of {formList?.sections?.length || 1}
            </span>

            <button
                className="next-section-btn"
                disabled={activeSection === (formList?.sections?.length || 1)}
                onClick={() => setActiveSection((prev) => prev + 1)}
            >
                Next Section
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.5 15L12.5 10L7.5 5" stroke="white" strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </button>
        </div>
    );
};
